/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Embedding } from './Embedding';
import {
    EmbeddingFromJSON,
    EmbeddingFromJSONTyped,
    EmbeddingToJSON,
} from './Embedding';

/**
 * 
 * @export
 * @interface EmbeddingResponseDto
 */
export interface EmbeddingResponseDto {
    /**
     * 
     * @type {Array<Embedding>}
     * @memberof EmbeddingResponseDto
     */
    data: Array<Embedding>;
}

/**
 * Check if a given object implements the EmbeddingResponseDto interface.
 */
export function instanceOfEmbeddingResponseDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function EmbeddingResponseDtoFromJSON(json: any): EmbeddingResponseDto {
    return EmbeddingResponseDtoFromJSONTyped(json, false);
}

export function EmbeddingResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmbeddingResponseDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(EmbeddingFromJSON)),
    };
}

export function EmbeddingResponseDtoToJSON(value?: EmbeddingResponseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(EmbeddingToJSON)),
    };
}

